/**
 * "Today awareness": if the device's local date falls within the trip,
 * auto-select that day on load; otherwise show all days.
 */

import { ALL_DAYS, type DaySelection, type Itinerary } from './types';

/** Format a Date as a local (not UTC) `YYYY-MM-DD` string. */
export function toISODateLocal(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Pick the day to select on load.
 * Returns the matching day's number when `now`'s local date equals a trip
 * day's date, otherwise {@link ALL_DAYS}.
 */
export function autoSelectDay(itinerary: Itinerary, now: Date): DaySelection {
  const today = toISODateLocal(now);
  const match = itinerary.days.find((d) => d.date === today);
  return match ? match.n : ALL_DAYS;
}
